export default {
  'go-to:entities': 'alt+1',
  'go-to:rules': 'alt+2',
  'go-to:intents': 'alt+3',
  'go-to:test-sets': 'alt+4',
  'go-to:dictionaries': 'alt+5',
  'go-to:contexts': 'alt+6',
  'go-to:files': 'alt+7',
  'go-to:xpacks': 'alt+8',
  'go-to:flow': 'alt+9',
};
